/**
 * Converts dimensions abbreviations to uppercase, with special handling for 'EdS'.
 */
export function abbrToUppercase(abbreviation: string): string {
  const upperAbbr = abbreviation.toUpperCase();
  return upperAbbr === 'EDS' ? 'EdS' : upperAbbr;
}
